import circle from '@turf/circle'
import React, { FunctionComponent, useState } from 'react'
import { useHistory } from 'react-router-dom'
import {
  Button,
  Form,
  Grid,
  GridColumn,
  GridRow,
  Header,
  Input,
  Menu,
  MenuItem,
  Modal,
  ModalContent, Search, Segment, Tab, TabPane, TabProps
} from 'semantic-ui-react'
import { FormProps } from 'semantic-ui-react/dist/commonjs/collections/Form/Form'
import { useAppDispatch } from '../../common/store'
import { LAYER_AERIAL_PHOTOGRAPHY_PATH, AP_POINT_RADIUS_MIN, AP_POINT_RADIUS_MAX } from '../../environment'
import {
  SEARCH_BY_POINT,
  SearchFilters,
  selectParcelByPolygon,
  updateAdvancedSearchFilters,
  updateSearchValue,
} from './ap.slice'

import './APAdvancedSearchComponent.css'
import APPlacenameSearchBar from "./APPlacenameSearchBar";

import {clearSelectFrame} from "./apFrames.slice";
import {APUtils} from "./ap.util";

import APCoordinateSearchPanel from "./APCoordinateSearchPanel";



const APAdvancedSearchComponent: FunctionComponent<{ showSearchResults(): void; }> = (props) => {

  const initialSearchState = {
    latitude: -12.46099,
    longitude: 130.83718,
    radius: 1000
  }

  const dispatch = useAppDispatch()
  const history = useHistory()
  const [searchFilters, setSearchFilters] = useState<SearchFilters>(initialSearchState)
  const [open, setOpen] = useState(false)

  function handleChange(e: React.FormEvent<HTMLFormElement>, {name, value}: FormProps) {
    setSearchFilters(prevState => ({
          ...prevState, [name]: value,
        }),
    )
    dispatch(updateAdvancedSearchFilters({[name]: value}))
  }

  function handleSubmit() {
    if (searchFilters.latitude && searchFilters.longitude) {
      let address = (searchFilters.address === undefined ? '' : searchFilters.address)
      let longitude = Number(searchFilters.longitude)
      let latitude = Number(searchFilters.latitude)

      searchFilters.radius = searchFilters.radius || 1000

      // @ts-ignore defined in the environment.ts with a default value
      if (searchFilters.radius < AP_POINT_RADIUS_MIN) {
        searchFilters.radius = AP_POINT_RADIUS_MIN
      }
      // @ts-ignore defined in the environment.ts with a default value
      if (searchFilters.radius > AP_POINT_RADIUS_MAX) {
        searchFilters.radius = AP_POINT_RADIUS_MAX
      }

      let url = APUtils.buildCoordinateSearchPath(longitude, latitude, searchFilters.radius!)

      dispatch(updateSearchValue(address))
      dispatch(clearSelectFrame())
      history.push(url)

      const polygon = toPolygon(longitude, latitude, searchFilters.radius!)
      dispatch(selectParcelByPolygon({geometry: polygon.geometry, projection: 'EPSG:4326'}))

      setSearchFilters(initialSearchState)
      setOpen(false)
    }
  }

  function toPolygon(longitude: number, latitude: number, radius: number) {
    return circle([longitude, latitude], radius, {units: 'meters'})
  }

  // Placename search and Coordinate search should be on their own tabs
  const searchPanes = () => {
    return [
      {
        menuItem: 'Coordinate',
        render: () => <TabPane attached={true} >
          <Grid columns={2} stackable={true}>
            <APCoordinateSearchPanel handleChange={handleChange}
                                     defaultLatitude={initialSearchState.latitude}
                                     defaultLongitude={initialSearchState.longitude}
                                     defaultRadius={searchFilters.radius} />
          </Grid>
        </TabPane>
      },
      {
        menuItem: 'Placename',
        render: () => <TabPane attached={true}>
          <Grid columns={1} stackable={true}>
            <APPlacenameSearchBar setSearchFilters={setSearchFilters} setRadiusChange={handleChange}
                                  defaultRadius={searchFilters.radius}/>
          </Grid>
        </TabPane>
      }
    ]
  }

  return (
    <Modal
      className={'searchModal'}
      centered={true}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      closeIcon={{style: { top: '0.6rem', left: '1rem'}, color: 'black', name:'close'}}
      trigger={
        <div className={'apAdvancedSearchBtn'}>
          <Button compact size={'tiny'} primary>Advanced Search</Button>
        </div>
      }>
      <Modal.Header>
      <Header as={"h3"} textAlign={"center"}>
        Advanced Search
      </Header>
    </Modal.Header>
      <ModalContent>
        <Form size={'small'} className={'searchForm'} autoComplete={'off'} >
          <Tab panes={searchPanes()}
               onTabChange={(e, data) => {
                 setSearchFilters(initialSearchState)
               }}
                />

          <Grid columns={2} style={{marginTop: "1em"}}>
          <GridRow>
            <GridColumn>
              <Button name={'searchBy'} compact primary onClick={(event) => handleSubmit()}>Search</Button>
            </GridColumn>
          </GridRow>
          </Grid>
        </Form>
      </ModalContent>
    </Modal>
  )

}

export default APAdvancedSearchComponent